/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import Vue from 'vue';
import Vuex from 'vuex';
import { getStoreBuilder } from '@codegrade/vuex-typex';
import { signal } from '@/utils';
import analytics from './modules/analytics';
import plagiarism from './modules/plagiarism';
import rubrics from './modules/rubrics';
import users from './modules/users';
import * as persist from './persist';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { UserStore } from './modules/user';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { NotificationStore } from './modules/notification';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { FeedbackStore } from './modules/feedback';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { PeerFeedbackStore } from './modules/peer_feedback';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { AssignmentsStore } from './modules/assignments';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { SubmissionsStore } from './modules/submissions';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { CoursesStore } from './modules/courses';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { SiteSettingsStore } from './modules/siteSettings';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { UIPrefsStore } from './modules/ui_prefs';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { TenantsStore } from './modules/tenants';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { FileTreeStore } from './modules/file_trees';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { GradersStore } from './modules/graders';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { AutoTestStore } from './modules/autotest';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { SubmissionOrderStore } from './modules/submission-order';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { CodeStore } from './modules/code';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export { PreferenceStore } from './modules/preference';
/** @inheritdoc */
export { EditorSessionsStore } from './modules/editor-sessions';
/** @inheritdoc */
export { SAFEStore } from './modules/safe';
/** @inheritdoc */
export { SectionsStore } from './modules/sections';
/** @inheritdoc */
export { ATv2OutputStore } from './modules/atv2_output';
/** @inheritdoc */
export { AssistantsStore } from './modules/assistants';
/** @inheritdoc */
export { JupyterStore } from './modules/jupyter';
Vue.use(Vuex);
const rootBuilder = getStoreBuilder();
Object.entries({
    rubrics,
    analytics,
    plagiarism,
    users,
}).forEach(([key, value]) => {
    const builder = rootBuilder.module(key);
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    builder.vuexModule = () => value;
});
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const store = rootBuilder.vuexStore({ strict: false });
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function onVueCreated(vue) {
    persist.onVueCreated(vue);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const disablePersistance = persist.disablePersistance;
const creatingPromise = signal.STORE_CREATED.sendPromise(store);
/** @returns A Promise that resolves when the store has been created. */
export async function waitTillStoreCreated() {
    await creatingPromise;
}
